import { client } from 'lib/evi-api-gateway';

import * as folderTypes from 'types/folder';

const folder = `${process.env.REACT_APP_API_URL_RESOURCE}/api/folder`;

export async function get_course_resource_list(
  params: folderTypes.get_course_resource_list_params
) {
  return client.post({
    url: `${folder}/get_course_resource_list`,
    form: {
      ...params
    }
  });
}

export async function add_course_folder(params: folderTypes.add_course_folder_params) {
  return client.post({
    url: `${folder}/add_course_folder`,
    form: {
      ...params
    }
  });
}

// export async function get_course_folder_id(params: folderTypes.get_course_folder_id_params) {
//   return client.post({
//     url: `${folder}/get_course_folder_id`,
//     form: {
//       ...params
//     }
//   });
// }

export async function get_resource_list(params: folderTypes.get_resource_list_params) {
  return client.post({
    url: `${folder}/get_resource_list`,
    form: {
      ...params
    }
  });
}
